//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {directive, Swiper, SwiperSlide} from 'vue-awesome-swiper'
import landingStyles from "@/components/mixins/landingStyles";
import ArrowCodeIcon from "@/assets/icons/arrows/ArrowCodeIcon.svg?inline";
import SectionTools from "@/components/landing/elements/SectionTools";
import LandingText from "@/components/landing/elements/LandingText";

export default {
  name: "LandingSectionStats",
  components: {
    LandingText,
    SectionTools,
    ArrowCodeIcon,
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive
  },
  mixins: [
    landingStyles
  ],
  props: {
    section: {
      type: Object,
      default: () => {
      }
    },
    currentIndex: {
      type: Number,
      default: 0
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      showButtonNext: false,
      showButtonPrev: false,
      swiperOption: {
        init: false,
        updateOnWindowResize: true,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        breakpoints: {
          '768': {
            slidesPerView: 2,
          },
          '992': {
            slidesPerView: 3,
          },
          '1200': {
            slidesPerView: 4,
          },
        }
      },
      showTools:false,
      containerSize: {
        width: 0,
        height: 0
      },
    }
  },
  computed:{
    backgroundImage(){
      const imageId = this.section.styles.backgroundImage ?? ''

      return (imageId === '')? '' :`${process.env.BACKEND_BASE_URL}/api/v2/landing/${imageId}/image`
    },
  },
  mounted() {
    this.$refs.statsSlider.$swiper.init()

    if (this.editable)
      this.updateSectionSizes()
  },
  methods: {
    updateSectionSizes(){
      this.containerSize.width = this.$refs[`container_${this.section.id}`].clientWidth
      this.containerSize.height = this.$refs[`section_${this.section.id}`].clientHeight
    },
    changeSlide(prev = false) {
      if (prev)
        this.$refs.statsSlider.$swiper.slidePrev()
      else
        this.$refs.statsSlider.$swiper.slideNext()
    },
    onSliderInit(swiper) {
      if (!this.editable) {
        this.showButtonNext = true
      }
      this.onSlideChange(swiper)
    },
    onSlideChange(swiper) {
      this.showButtonNext = !swiper.isEnd
      this.showButtonPrev = !swiper.isBeginning
    },
    updateSection() {
      this.updateSectionSizes()
      this.$store.dispatch('landing/updateSection', {section: this.section, index: this.currentIndex})
    },
  },
}
